import { render, staticRenderFns } from "./FormInputBoolean.vue?vue&type=template&id=e64521ca"
import script from "./FormInputBoolean.vue?vue&type=script&lang=js"
export * from "./FormInputBoolean.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports